import { createSlice } from '@reduxjs/toolkit';
import {
  getSupplierBuyersExtraReducer,
  updateSupplierBuyerExtraReducer,
  supplierUpdateBuyerUserPermissionsExtraReducer,
  supplierDeleteBuyerUserExtraReducer,
  getBuyerStatementPeriodsExtraReducer,
  sendEmailStatementsForBuyersWithStatementIdExtraReducer,
} from '../reducers/supplierBuyersReducers';
import { Buyer } from '@dill/dill-shared';

export interface SupplierBuyersInitialState {
  loadingList: string[];
  supplierBuyers: Buyer[];
  loadingErrorList: object[];
  statementPeriods: { id: string; statementDate: any }[];
}

const initialState: SupplierBuyersInitialState = {
  loadingList: [],
  supplierBuyers: [],
  loadingErrorList: [],
  statementPeriods: [],
};

export const supplierBuyersSlice = createSlice({
  name: 'supplierBuyers',
  initialState,
  reducers: {
    resetSupplierBuyersRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierBuyersExtraReducer(builder);
    updateSupplierBuyerExtraReducer(builder);
    supplierUpdateBuyerUserPermissionsExtraReducer(builder);
    supplierDeleteBuyerUserExtraReducer(builder);
    getBuyerStatementPeriodsExtraReducer(builder);
    sendEmailStatementsForBuyersWithStatementIdExtraReducer(builder);
  },
});

export const { resetSupplierBuyersRootState } = supplierBuyersSlice.actions;
